import { FormValidation } from './utilities/form-validation';

const login = {
  // Login action URLs
  actionUrl: '',
  actionUrlLightbox: '',
  actionUrlJson: '',

  // Login status
  isLoggedIn: false,
  name: '',
  company: '',

  /**
   * Things which have to be updated on each callback
   */
  update: function () {
    document.querySelectorAll('.login-form-container form input[type="text"], input[type="password"]').forEach(input => {
      input.setAttribute('autocomplete', 'off');
    });

    login.pollStatus();
    login.bindErrorHandling();
  },

  /**
   * Poll login status
   * and store in variable
   */
  pollStatus: function () {
    if (!login.actionUrlJson) {
      login.actionUrlJson = document.querySelector('[data-status-url]').getAttribute('data-status-url');
    }
    fetch(login.actionUrlJson, {
      cache: 'no-cache'
    })
      .then(response => response.json())
      .then(statusInformation => {
        login.isLoggedIn = statusInformation.isLoggedIn;
        if (statusInformation.isLoggedIn) {
          document.body.classList.add('mw-logged-in');
        } else {
          document.body.classList.remove('mw-logged-in');
        }

        login.name = statusInformation.name;
        if (login.name !== '') {
          login.setName();
        }
        login.company = statusInformation.company;
        if (login.company !== '') {
          if (login.name !== '') {
            login.company = ', ' + login.company;
          }
          login.setCompany();
        }

        // callback function
        if (typeof login.pollLoginCallback === 'function') {
          login.pollLoginCallback.call(this);
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
  },

  setName: function() {
    document.querySelector('.login-form-container .name').textContent = login.name;
  },

  setCompany: function() {
    document.querySelector('.login-form-container .company').textContent = login.company;
  },

  /**
   * Process FE login
   */
  sendLoginRequest: function (formEl) {
    // eslint-disable-next-line no-undef
    activityIndicator.attach();

    const form = new FormData(formEl);
    const formContainer = formEl.closest('.login-form-container');
    const params = new URLSearchParams(form).toString();
    const url = formContainer.classList.contains('login-form-container__lightbox') ? login.actionUrlLightbox : login.actionUrl;

    fetch(url, {
      method: 'POST',
      body: params,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
      .then(response => response.json())
      .then(response => {
        if (response.action === 'redirect' && response.redirectUrl !== '') {
          // eslint-disable-next-line no-undef
          activityIndicator.detach();
          window.location.href = response.redirectUrl;
        } else {
          if (typeof login.actionCallback === 'function') {
            login.actionCallback.call(this, response.message);
          } else {
            const deviantForm = document.querySelector('.fancybox-inner form#tx_mwlogin_login_deviant');
            if (deviantForm) {
              deviantForm.closest('.login-form-container').replaceWith(response);
            } else {
              formContainer.outerHTML = response;
              // Set login status and parse response for error message div
              const loginSuccess = !response.includes('error-message');
              if (loginSuccess) {
                document.getElementById('user-login-status').classList.add('btn--user-logged-in');
              }

              // Reselect replaced login form or you will get data from first form sending - GSONE-1256
              login.context = document.querySelector(login.classname);
              login.update();
            }

            if (typeof login.trackingCallback === 'function') {
              login.trackingCallback.call(this, response.message);
            }
            // eslint-disable-next-line no-undef
            activityIndicator.detach();
          }
        }
      })
      .catch(error => {
        console.error('Error:', error);
        // eslint-disable-next-line no-undef
        activityIndicator.detach();
      });
  },

  setFormContent: function(formContainer, html) {
    // Replace the form with the submission response
    formContainer.outerHTML = html;
    login.update();

    // Update other login forms to be up to date
    fetch(login.actionUrl, {
      cache: 'no-cache'
    })
      .then(response => response.text())
      .then(otherHtml => {
        document.querySelectorAll('.login-form-container-normal:not([data-has-latest-used-login-box]) .login-form-container-normal')
          .forEach(container => container.outerHTML = otherHtml);
        login.update();
      })
      .catch(error => console.error('Error:', error));
  },

  bindErrorHandling: function() {
    const validatingInputs = Array.from(document.querySelectorAll('[data-validation]'));
    validatingInputs.forEach(item => {
      const errorMsg = item.getAttribute('data-error-msg');
      item.addEventListener('invalid', (event) => {
        if (!item.validity.valid) {
          if (!item.closest('.c-form-group').querySelector('.c-form-validation')) {
            item.closest('.c-form-group').insertAdjacentElement('beforeend', new FormValidation(event.currentTarget).formValidationMessage('error', errorMsg));
            new FormValidation(event.currentTarget).customValidity('text', errorMsg);
          }
        }
      });
      item.addEventListener('input', () => {
        if (item.nextElementSibling) {
          item.nextElementSibling.remove();
        }
      });
    });
  },

  initialize: function () {
    'use strict';

    login.update();

    const body = document.body;
    const registerForm = document.querySelector('form.login-register-box');
    if (registerForm) {
      const actionUrl = registerForm.getAttribute('action');
      login.actionUrl = actionUrl + 'loginform.html';
      login.actionUrlLightbox = actionUrl + 'loginlightbox.html';
      login.actionUrlJson = actionUrl + 'loginstatus.json';
    }


    // prevents multiple binding, quick-fix for GSONE-939
    body.removeEventListener('submit', login.formSubmitHandler);
    body.addEventListener('submit', login.formSubmitHandler);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  login.initialize();
});

export default {};
